import { SCRIPT_NAME } from "../../common/constants";
import { convertWidgetUrlToLinkFormUrl, extractHostname } from "../../common/utils/url";

const checkoutSrc =
    (document.currentScript as HTMLScriptElement)?.src ||
    document.querySelector(`script[src$="${SCRIPT_NAME}"]`)?.getAttribute("src") ||
    undefined;

let linkFormUrl = LINK_FORM_URL;
let checkoutBaseUrl = CHECKOUT_URL;
if (checkoutSrc) {
    const a = document.createElement("a");
    a.href = checkoutSrc;

    const domain = extractHostname(checkoutSrc);

    // Removing the SRI from the URL to ensure we always load the latest checkout to prevent merchant
    // from using a older version that may contain bugs
    checkoutBaseUrl = `${a.protocol}//${domain?.replace("-sri", "")}:${a.port}`;
    linkFormUrl = convertWidgetUrlToLinkFormUrl(checkoutBaseUrl);
}

export const BASE_CHECKOUT_URL = checkoutBaseUrl;
export const FULL_CHECKOUT_URL = `${checkoutBaseUrl}/checkout/index.html`;

export const BASE_LINK_FORM_URL = linkFormUrl;
export const FULL_LINK_FORM_URL = `${linkFormUrl}/forms/widget`;
